<template>
  <div>
    <list-editor :column-keys="columnKeys"
                 :items="list"
                 :loading="loading"
                 :showSearchBar="true"
                 :showAddButton="true"
                 :showExportButton="true"
                 @addData="addData"
                 @editData="edit"
                 @saveData="save"
                 @searchData="searchData"
    @exportData="exportData"></list-editor>

    <!--彈出視窗-->
    <v-dialog
      v-model="dialogFormVisible"
      persistent
      :max-width="width">
      <v-card>
        <v-card-title class="headline">
          編輯
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-tabs v-model="tab">
            <v-tab>個人資料</v-tab>
            <v-tab>功能設定</v-tab>
            <v-tab>銀行帳戶</v-tab>
            <v-tab>檔案權限</v-tab>
          </v-tabs>
          <br>
          <v-tabs-items v-model="tab">
            <v-tab-item key="個人資料">
              <v-layout v-for="col in dialogKeys"
                        :key="col.key">
                <v-flex xs12 sm12 d-flex v-if="col.key === 'authority'">
                  <v-select :items="authorityKeys"
                            v-model="itemDetail[col.key]"
                            item-text="label"
                            item-value="key"
                            :label="$t('authority')"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm12 d-flex v-else-if="col.key === 'agentId'">
                  <span>用戶編號：{{itemDetail[col.key]}}</span>
                </v-flex>
                <v-flex xs12 sm12 d-flex v-else-if="col.key === 'menuList'">
                  <v-select :items="menuKeys" multiple
                            v-model="itemDetail[col.key]"
                            item-text="name"
                            item-value="path"
                            :label="$t('action_permission')"
                  ></v-select>
                </v-flex>
                <v-flex xs12 v-else-if="col.key === 'bankImageURL'">
                  <div class="file">
                    <span v-if="uploadedFiles.length === 0">{{$t('choose_image')}}</span>
                    <input v-if="uploadedFiles.length === 0"
                           type="file" multiple :name="uploadFieldName"
                           @change="filesChange($event.target.name, $event.target.files)"
                           accept="image/*" class="input-file">
                    <span v-else>已選擇圖片</span>
                  </div>
                  <div style="width: 100%;">
                    <img v-if="itemDetail[col.key] !== ''" :src="itemDetail[col.key]"
                         style="width: 400px; margin-top: 10px;"/>
                  </div>
                </v-flex>
                <v-flex xs12 v-else-if="col.key === 'password' || col.key === 'checkPassword'">
                  <v-text-field v-model="passwordInfo[col.key]"
                                :rules="col.rules"
                                :type="`password`"
                                :label="col.label"
                                :disabled="false"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 v-else-if="col.key === 'financeBonusRate'">
                  <v-select v-model="itemDetail[col.key]"
                            :label="col.label"
                            :items="bonusKeys"
                            item-text="key"
                            item-value="value"></v-select>
                </v-flex>
                <v-flex xs12 v-else>
                  <v-text-field v-model="itemDetail[col.key]"
                                :rules="col.rules"
                                :type="`text`"
                                :label="col.label"
                                :disabled="col.disabled"
                  ></v-text-field>
                </v-flex>

              </v-layout>
            </v-tab-item>
            <v-tab-item key="功能設定">
              <v-layout v-for="col in optionsDialogKeys"
                        :key="col.key">
                <v-flex xs12 sm12 d-flex>
                  <v-switch
                    v-model="itemDetail[col.key]"
                    :label="col.label"
                  ></v-switch>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item key="銀行帳戶">
              <v-layout v-for="col in bankDialogKeys"
                        :key="col.key">
                <v-flex xs12 v-if="col.key === 'bankImageURL'">
                  <div class="file">
                    <span v-if="uploadedFiles.length === 0">{{$t('choose_image')}}</span>
                    <input v-if="uploadedFiles.length === 0"
                           type="file" multiple :name="uploadFieldName"
                           @change="filesChange($event.target.name, $event.target.files)"
                           accept="image/*" class="input-file">
                    <span v-else>已選擇圖片</span>
                  </div>
                  <div style="width: 100%;">
                    <img v-if="itemDetail[col.key] !== ''" :src="itemDetail[col.key]"
                         style="width: 400px; margin-top: 10px;"/>
                  </div>
                </v-flex>
                <v-flex xs12 v-else>
                  <v-text-field v-model="itemDetail[col.key]"
                                :rules="col.rules"
                                :type="`text`"
                                :label="col.label"
                                :disabled="col.disabled"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab-item key="檔案權限" >
              <div v-if="itemDetail && itemDetail.categoryList && itemDetail.categoryList.length">
                <v-layout v-for="(col, i) in fileCategoryList"
                          :key="col.projectId">
                  <v-flex xs12 sm12 d-flex>
                    <v-switch v-if="itemDetail.categoryList[i]"
                      v-model="itemDetail.categoryList[i].enable"
                      :label="col.name"
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </div>
            </v-tab-item>
          </v-tabs-items>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" dark text @click="cancelEvent">取消</v-btn>
          <v-btn class="primary" dark text :loading="saveLoading" @click="save">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--彈出視窗-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.content"
                :show-cancel="false"
                @confirmEvent="confirmEvent"></alert-view>
  </div>
</template>

<script>
  import AlertView from '@/components/AlertView';
  import ListEditor from '../../components/ListEditor';
  import { mapActions, mapGetters } from 'vuex';

  import MobileDetect from 'mobile-detect';
  import common from '@/mixins/common';
  import { saveAgentToken } from '@/store/actions';
  import { exportAgentListFile } from '../utils/tool';
  const md = new MobileDetect(window.navigator.userAgent);
  export default {
    name: 'AgentView',
    components: {
      AlertView,
      ListEditor,
    },
    mixins: [common],
    data() {
      return {
        tab: null,
        list: [],
        loading: false,
        width: md.phone() ? '80%':'60%',
        dialogFormVisible: false,
        dialogUpdatePassword: false,
        dialogPaymentView: false,
        saveLoading: false,
        mode: 'insert',
        showVendorBonus: false,
        itemDetail: null,
        defaultItem: {
          agentId: '',
          email: '',
          displayName: '',
          cellphone: '',
          authority: 'agent',
          enable: true,
          agentNumber: '',
          menuList: [],
          actionList: [],
          fileList: [],
          parentAgent: {
            rootAgent: '',
            agentId: ''
          },
          accountName: '',
          bankName: '',
          bankSubName: '',
          bankAccount: '',
          bankImageURL: '',
          fees: 0,
          isDeduct: false,
          comment: '',
          generalBonus: {
            oneYear: 120,
            twoYear: 170,
          },
          otherBonus: 10, // 10%
          compNo: [],
          recyclePrice: 50,
          ecuBonus: 0,
          vendorBonus: 0, //經銷佣金
          financeName: '', //經辦姓名
          financePhone: '',//經辦電話
          financeBonusRate:'', //原融佣金比率
          enableFinanceAgent: false, //顯示經辦,
          isFinanceOfficial: false, //是否可連結裕富
          enableAgentContract: false, //顯示代辦合約
          enableLoanhfc: false, //是否開啟和潤申請書
          enableAdminFinance: false, //是否開啟業務進件功能
          enableRequestPayment: false, // 請款請求
          enableRequestForExam: false, // 案件申覆爭取
          enableRequestForExamSearch: false,
          enableRequestSupplement: false, // 審件補件
          enableQueryCaseStatus: false, // 案件狀態查詢
          enableReCallout: false, // 重新照會通知
          enablePaymentTool: false, // 啟用收款工具
          enableChooseCommissionTarget: false, // 啟用可選撥佣對象
          enableCompanyDoc: false, // 內帳
          enableToken: false, // 啟用暫時權限
          enableGooddealList: false,
          salesId: '', //業務身分證
          notifyMail: '', // 接收通知的mail
          categoryList: [],
        },
        dateInfo: {
          start: {
            year: '',
            month: '',
            day: '',
            isRepublic: false,
            onlyMonth: false,
            onlyOneYear: true
          },
          end: {
            year: '',
            month: '',
            day: '',
            isRepublic: false,
            onlyMonth: false,
            onlyOneYear: true
          }
        },
        passwordInfo: {
          password: '',
          checkPassword: ''
        },
        emailRules: [
          v => !!v || 'E-mail是必填欄位',
          v => /.+@.+\..+/.test(v) || 'E-mail格式錯誤',
        ],
        passwordRules: [
          v => !!v || '密碼是必填欄位',
          v => v.length >= 6 || '密碼最少六位數',
        ],
        uploadedFiles: [],
        uploadFieldName: 'photos',
        searchInfo: {
          keyword: '',
        },
        messageDialog: {
          title: '',
          content: '',
          visible: false,
          confirm: () => {
          },
          cancel: () => {
          },
        },
        fileCategoryList: [],
      };
    },
    created() {
      this.itemDetail = Object.assign({} , this.defaultItem);
      this.loadData();
    },
    watch:{
      async 'itemDetail.enableToken'(value) {
        console.log(`enableToken == ${value} | ${this.itemDetail.agentId}`);
        if (value === true) {
          if (this.itemDetail.agentId) {
            const res = await this.saveAgentToken({ agentId: this.itemDetail.agentId });
            const result = res.data;

            console.log(`token == ${result.data.token}`);
            this.itemDetail.token = result.data.token;
          }
        }
      }
    },
    computed: {
      ...mapGetters(['getAgentList', 'getUserInfo']),
      agentList() {
        // console.log(`this.getAgentList ${this.getAgentList.length}`);
        if (this.isAdmin) {
          // let list = this.getAgentList.filter(agent => !agent.isDeleted && agent.authority !== 'admin');
          let list = this.getAgentList.filter(agent => !agent.isDeleted);
          if (this.searchInfo.keyword !== '') {
            return list.filter(agent => {
              const key = `${agent.displayName}${agent.agentNumber}${agent.salesName}`;
              return key.indexOf(this.searchInfo.keyword) > -1;
            });
          }
          console.log(`admin agents count ${list.length}`);
          return list;
        } else {
          let list = this.getAgentList.filter(agent => !agent.isDeleted
            && agent.parentAgent && agent.parentAgent.agentId === this.getUserInfo.agentId);
          console.log(`other agents count ${list.length}`);
          if (this.searchInfo.keyword !== '') {
            return list.filter(agent => {
              const key = `${agent.displayName}${agent.agentNumber}${agent.salesName}`;
              return key.indexOf(this.searchInfo.keyword) > -1;
            });
          }
          return list;
        }
      },
      columnKeys() {
        const list = [
          { value: 'tools', text: '編輯', sortable: false},
          { value: 'email', text: this.$t('account'), sortable: true },
          { value: 'authority', text: this.$t('authority') },
          { value: 'displayName', text: this.$t('vendorName'), sortable: true },
          { value: 'cellphone', text: this.$t('cellphone'), sortable: true },
          { value: 'agentNumber', text: this.$t('agentNumber'), sortable: true },
          { value: 'salesName', text: this.$t('salesName') },
          { value: 'enable', text: '啟用', sortable: false },
        ];
        return list;
      },
      dialogKeys() {
        let list = [
          { key: 'agentId', label: this.$t('agentId') },
          { key: 'email', label: this.$t('account') , rules: this.emailRules, disabled: this.mode === 'edit' },
          { key: 'password', label: this.$t('password'), rules: this.passwordRules,  },
          { key: 'checkPassword', label: this.$t('checkPass') , rules: this.passwordRules },
          { key: 'displayName', label: this.$t('vendorName') },
          { key: 'agentNumber', label: this.$t('agentNumber') },
          // { key: 'salesName', label: this.$t('salesName') },
          { key: 'salesId', label: '身分證'},
          { key: 'department', label: '部門' },
          { key: 'cellphone', label: this.$t('cellphone') },
          { key: 'authority', label: this.$t('authority') },
          { key: 'menuList', label: this.$t('action_permission') },
          { key: 'financeName', label: this.$t('financeName') },
          { key: 'financePhone', label: this.$t('financePhone') },
          { key: 'financeBonusRate', label: '前佣%' },
          { key: 'commissionTarget', label: '撥佣對象(統編/身分證號)' },
          { key: 'dealerBranchNo', label: '據點代號' },
          { key: 'dealerBranchName', label: '據點名稱' },
          { key: 'dealerContactName', label: '據點聯絡人' },
          { key: 'dealerContactPhone', label: '據點聯絡人手機' },
          { key: 'insurePrice', label: '對保費' },
          { key: 'richInsurePrice', label: '裕富對保費' },
          { key: 'richNInsurePrice', label: '裕富N專案對保費' },
          { key: 'finatradeInsurePrice', label: '中租對保費' },
          { key: 'loanhftcInsurePrice', label: '和潤對保費' },
          { key: 'century21InsurePrice', label: '21世紀對保費' },
          // { key: 'accountName', label: this.$t('accountName') },
          // { key: 'bankName', label: this.$t('bankName') },
          // { key: 'bankSubName', label: this.$t('bankSubName') },
          // { key: 'bankAccount', label: this.$t('bankAccount') },
          // { key: 'bankImageURL', label: this.$t('bankImageURL') },
          { key: 'notifyMail', label: '接收通知的Mail' },
          { key: 'comment', label: this.$t('comment') },
        ];
        if (this.isAdmin || this.isSales) {
          if (this.mode === 'insert'){
            return list.filter(m=>m.key !== 'agentId');
          }
          if (this.mode === 'edit'){
            return list.filter(m=>m.key !== 'password' && m.key !== 'checkPassword');
          }
          return list;
        }
        return [
          { key: 'email', label: this.$t('account') },
          { key: 'password', label: this.$t('password') },
          { key: 'checkPassword', label: this.$t('checkPass') },
          { key: 'displayName', label: this.$t('displayName') },
          { key: 'cellphone', label: this.$t('cellphone') },
        ];
      },
      bankDialogKeys() {
        return [
          { key: 'accountName', label: this.$t('accountName') },
          { key: 'bankName', label: this.$t('bankName') },
          { key: 'bankSubName', label: this.$t('bankSubName') },
          { key: 'bankAccount', label: this.$t('bankAccount') },
          { key: 'bankImageURL', label: this.$t('bankImageURL') },
        ];
      },
      optionsDialogKeys() {
        return [
          { key: 'enable', label: '啟用帳號', sort: false },
          { key: 'isFinanceOfficial', label: '是否可進件至裕富', sort: false },
          { key: 'enableAgentContract', label: '是否啟用代辦合約功能', sort: false },
          { key: 'enableLoanhfc', label: '是否開啟和潤申請書', sort: false },
          { key: 'enableAdminFinance', label: '是否開啟原融業務進件功能', sort: false },
          { key: 'enablePaymentView', label: '是否開啟待撥清單功能', sort: false },
          { key: 'enableRequestPayment', label: '是否開啟請款請求功能', sort: false },
          { key: 'enableRequestForExam', label: '是否開啟案件申覆爭取功能', sort: false },
          { key: 'enableRequestForExamSearch', label: '是否開啟案件申覆紀錄查詢功能', sort: false },
          { key: 'enableRequestSupplement', label: '是否開啟審件補件功能', sort: false },
          { key: 'enableQueryCaseStatus', label: '是否開啟案件狀態查詢功能', sort: false },
          { key: 'enableReCallout', label: '是否開啟重新照會通知功能', sort: false },
          { key: 'enablePaymentTool', label: '是否開啟收款工具', sort: false },
          { key: 'enableEditCommissionTarget', label: '是否可以修改撥佣對象/據點代號/據點名稱', sort: false },

          { key: 'enableAgent', label: '開啟經銷業務管理', sort: false },
          { key: 'enableInstallmentReplyView', label: '開啟裕富申覆管理', sort: false },
          { key: 'enableEntrepreneurCreditList', label: '開啟中租進件管理', sort: false },
          { key: 'enableLoanhfcCreditList', label: '開啟和潤進件管理', sort: false },
          { key: 'enableCaList', label: '開啟商品貸管理', sort: false },
          { key: 'enableGooddealList', label: '開啟賀丞交案件管理', sort: false },
          { key: 'enableCCH21FinanceList', label: '開啟21世紀案件管理', sort: false },
          { key: 'enableCreditLoanList', label: '開啟信貸管理', sort: false },
          { key: 'enableEditCreditProduct', label: '開啟後台進件系統', sort: false },
          { key: 'enableChooseCommissionTarget', label: '開啟指定撥佣對象', sort: false },
          { key: 'enableCompanyDoc', label: '開啟內帳權限', sort: false },
          { key: 'enableToken', label: '開啟暫時檢視權限', sort: false },
          { key: 'enableExport', label: '開啟匯出權限', sort: false },
          { key: 'enableEditPrice', label: '開啟案件金額與期數編輯', sort: false },
        ];
      },
      menuKeys() {
        if (this.isAdmin || this.isAgent) {
          return [
            { name: this.$t('menu-agents'), path: '/dashboard/agents' },
            { name: this.$t('financeList'), path: '/dashboard/financeList' },
            { name: this.$t('mortgageList'), path: '/dashboard/mortgageList' },
            { name: this.$t('FinanceCreditList'), path: '/dashboard/FinanceCreditList' },
          ];
        }
        return [
          { name: this.$t('financeList'), path: '/dashboard/financeList' },
          { name: this.$t('mortgageList'), path: '/dashboard/mortgageList' },
          { name: this.$t('FinanceCreditList'), path: '/dashboard/FinanceCreditList' },
        ];
      },
      authorityKeys() {
        let list = [];
        if (this.isAdmin) {
          list.push({ key: 'admin', label: this.$t('admin') });
          list.push({ key: 'manager', label: '專案經理' });
          list.push({ key: 'agent', label: '經銷商' });
          list.push({ key: 'insureAgent', label: this.$t('insureAgent') });
          list.push({ key: 'sales', label: this.$t('sales') });
          list.push({ key: 'store', label: this.$t('store') });
          list.push({ key: 'staff', label: '員工' });
          list.push({ key: 'accounting', label: '會計' });
        }
        if (this.isManager) {
          list.push({ key: 'agent', label: '經銷商' });
          list.push({ key: 'insureAgent', label: this.$t('insureAgent') });
          list.push({ key: 'sales', label: this.$t('sales') });
          list.push({ key: 'store', label: this.$t('store') });
          list.push({ key: 'staff', label: '員工' });
        }

        if (this.isAgent) {
          list.push({ key: 'sales', label: this.$t('sales') });
          list.push({ key: 'insureAgent', label: this.$t('insureAgent') });
        }
        if (this.isSales) {
          list.push({ key: 'store', label: this.$t('store') });
        }
        return list;
      },
      bonusKeys() {
        return [
          { key: '20.00%', value: '20.00' },
          { key: '19.75%', value: '19.75' },
          { key: '19.50%', value: '19.50' },
          { key: '19.25%', value: '19.25' },
          { key: '19.00%', value: '19.00' },
          { key: '18.75%', value: '18.75' },
          { key: '18.50%', value: '18.50' },
          { key: '18.25%', value: '18.25' },
          { key: '18.00%', value: '18.00' },
          { key: '17.75%', value: '17.75' },
          { key: '17.50%', value: '17.50' },
          { key: '17.25%', value: '17.25' },
          { key: '17.00%', value: '17.00' },
          { key: '16.75%', value: '16.75' },
          { key: '16.50%', value: '16.50' },
          { key: '16.25%', value: '16.25' },
          { key: '16.00%', value: '16.00' },
          { key: '15.75%', value: '15.75' },
          { key: '15.50%', value: '15.50' },
          { key: '15.25%', value: '15.25' },
          { key: '15.00%', value: '15.00' },
          { key: '14.75%', value: '14.75' },
          { key: '14.50%', value: '14.50' },
          { key: '14.25%', value: '14.25' },
          { key: '14.00%', value: '14.00' },
          { key: '13.75%', value: '13.75' },
          { key: '13.50%', value: '13.50' },
          { key: '13.25%', value: '13.25' },
          { key: '13.00%', value: '13.00' },
        ]
      }
    },
    methods: {
      ...mapActions(['fetchAgentList', 'updateData', 'createAgent', 'saveAgent', 'removeData', 'deleteAgent'
        , 'uploadImageData', 'getImageUrl', 'disableUser','createNewAgent','loadCCHProjects', 'saveAgentToken']),
      async loadCategoryData() {
        const res = await this.loadCCHProjects({ category: 'fileType' });
        const result = res.data;
        this.fileCategoryList = [];
        for (let item of result.data ? result.data : []){
          this.fileCategoryList.push(item);
        }
        console.log(`fileCategoryList = ${JSON.stringify(this.fileCategoryList)}`);

        if (!this.itemDetail.categoryList) {
          this.itemDetail.categoryList = [];
          const list = this.fileCategoryList ? this.fileCategoryList : [];
          for (let item of list){
            item.enable = false;
            this.itemDetail.categoryList.push(item);
          }
          this.$forceUpdate();
        }
        console.log(`this.itemDetail.categoryList = ${JSON.stringify(this.itemDetail.categoryList)}`);
      },
      loadData(){
        this.fetchAgentList().then(()=>{
          if (this.isAdmin) {
            this.list = this.getAgentList.filter(agent => !agent.isDeleted);
          } else {
            this.list = this.getAgentList.filter(agent => !agent.isDeleted
              && agent.parentAgent && agent.parentAgent.agentId === this.getUserInfo.agentId);
          }
        });
      },
      confirmEvent() {
        this.messageDialog.visible = false;
      },
      cancelEvent() {
        this.dialogFormVisible = false;
        this.itemDetail = Object.assign({}, this.defaultItem);
      },
      searchData(value){
        console.log(`search ${JSON.stringify(value)}`);
        this.list = this.agentList.filter(agent=>{
          const key = `${agent.email}${agent.displayName}${agent.agentNumber}${agent.cellphone}`;
          return key.indexOf(value) > -1;
        });
      },
      exportData(){
        let columns = [
          { key: 'agentId', text: this.$t('agentId') },
          { key: 'email', text: this.$t('account')},
          { key: 'displayName', text: this.$t('vendorName') },
          { key: 'agentNumber', text: this.$t('agentNumber') },
          { key: 'salesId', text: '身分證'},
          { key: 'department', text: '部門' },
          { key: 'cellphone', text: this.$t('cellphone') },
          { key: 'authority', text: this.$t('authority') },
          { key: 'financeName', text: this.$t('financeName') },
          { key: 'financePhone', text: this.$t('financePhone') },
          { key: 'commissionTarget', text: '撥佣對象(統編/身分證號)' },
          { key: 'dealerBranchNo', text: '據點代號' },
          { key: 'dealerBranchName', text: '據點名稱' },
          { key: 'dealerContactName', text: '據點聯絡人' },
          { key: 'dealerContactPhone', text: '據點聯絡人手機' },

          { key: 'insurePrice', text: '對保費' },
          { key: 'richInsurePrice', text: '裕富對保費' },
          { key: 'richNInsurePrice', text: '裕富N專案對保費' },
          { key: 'finatradeInsurePrice', text: '中租對保費' },
          { key: 'loanhftcInsurePrice', text: '和潤對保費' },
          { key: 'century21InsurePrice', text: '21世紀對保費' },
        ];
        const list = this.getAgentList.filter(agent => !agent.isDeleted);
        console.log(`export = ${JSON.stringify(list)}`)
        exportAgentListFile("經銷業務匯出列表", columns, list);
      },
      reset() {
        this.searchInfo.keyword = '';
      },
      edit(row) {
        this.loadCategoryData();
        this.mode = 'edit';
        if (!row.menuList) {
          this.itemDetail = { ...row, menuList: [] };
        } else if (!row.fileList) {
          this.itemDetail = { ...row, fileList: [] };
        } else if (!row.compNo) {
          this.itemDetail = { ...row, compNo: [] };
        } else {
          this.itemDetail = { ...row };
        }

        if (!this.itemDetail.isDeduct) {
          this.itemDetail.isDeduct = false;
        }

        if (!this.itemDetail.recyclePrice) {
          this.itemDetail.recyclePrice = 50;
        }

        if (!this.itemDetail.ecuBonus) {
          this.itemDetail.ecuBonus = 0;
        }

        if (!this.itemDetail.vendorBonus) {
          this.itemDetail.vendorBonus = 0;
        }

        if (!this.itemDetail.salesId) {
          this.itemDetail.salesId = '';
        }

        if (!this.itemDetail.notifyMail) {
          this.itemDetail.notifyMail = '';
        }

        if (!this.itemDetail.parentAgent) {
          this.itemDetail.parentAgent = {
            rootAgent: 'Yd2Xn5V5xldYmGZbCvlK8bmfFHJ2',
          };
        }

        if (this.getUserInfo.agentId ===
          this.itemDetail.parentAgent.rootAgent || this.isAdmin) {
          this.showVendorBonus = true;
        } else {
          this.showVendorBonus = false;
        }


        if (!this.itemDetail.generalBonus || !this.itemDetail.generalBonus.oneYear) {
          this.itemDetail.generalBonus = {
            oneYear: 120,
            twoYear: 170,
          };
        }

        if (!this.itemDetail.otherBonus) {
          this.itemDetail.otherBonus = 10;
        }

        if (!this.itemDetail.isFinanceOfficial) {
          this.itemDetail.isFinanceOfficial = false;
        }

        if (!this.itemDetail.enableAgentContract) {
          this.itemDetail.enableAgentContract = false;
        }

        if (!this.itemDetail.enableLoanhfc) {
          this.itemDetail.enableLoanhfc = false;
        }

        if (!this.itemDetail.enableAdminFinance) {
          this.itemDetail.enableAdminFinance = false;
        }

        if (!this.itemDetail.enableRequestPayment) {
          this.itemDetail.enableRequestPayment = false;
        }

        if (!this.itemDetail.enableRequestForExam) {
          this.itemDetail.enableRequestForExam = false;
        }

        if (!this.itemDetail.enableRequestForExamSearch) {
          this.itemDetail.enableRequestForExamSearch = false;
        }

        if (!this.itemDetail.enableRequestSupplement) {
          this.itemDetail.enableRequestSupplement = false;
        }

        if (!this.itemDetail.enableQueryCaseStatus) {
          this.itemDetail.enableQueryCaseStatus = false;
        }

        if (!this.itemDetail.enableReCallout) {
          this.itemDetail.enableReCallout = false;
        }

        if (!this.itemDetail.enablePaymentTool) {
          this.itemDetail.enablePaymentTool = false;
        }

        if (!this.itemDetail.enableAgent) {
          this.itemDetail.enableAgent = false;
        }

        if (!this.itemDetail.enableInstallmentReplyView) {
          this.itemDetail.enableInstallmentReplyView = false;
        }

        if (!this.itemDetail.enableEntrepreneurCreditList) {
          this.itemDetail.enableEntrepreneurCreditList = false;
        }

        if (!this.itemDetail.enableLoanhfcCreditList) {
          this.itemDetail.enableLoanhfcCreditList = false;
        }

        if (!this.itemDetail.enableCaList) {
          this.itemDetail.enableCaList = false;
        }

        if (!this.itemDetail.enableCreditLoanList) {
          this.itemDetail.enableCreditLoanList = false;
        }

        if (!this.itemDetail.enableEditCreditProduct) {
          this.itemDetail.enableEditCreditProduct = false;
        }

        if (!this.itemDetail.commissionTarget) {
          this.itemDetail.commissionTarget = '';
        }

        if (!this.itemDetail.dealerBranchNo) {
          this.itemDetail.dealerBranchNo = '';
        }
        if (this.itemDetail.dealerBranchNo === ''){ // 預設
          this.itemDetail.dealerBranchNo = '54638631'
        }

        if (!this.itemDetail.dealerBranchName) {
          this.itemDetail.dealerBranchName = '';
        }
        if (this.itemDetail.dealerBranchName === ''){ // 預設
          this.itemDetail.dealerBranchName = '嘉好企業有限公司'
        }

        if (!this.itemDetail.dealerContactName) {
          this.itemDetail.dealerContactName = '';
        }

        if (!this.itemDetail.dealerContactPhone) {
          this.itemDetail.dealerContactPhone = '';
        }

        if (!this.itemDetail.enableEditCommissionTarget) {
          this.itemDetail.enableEditCommissionTarget = false;
        }

        if (!this.itemDetail.enableChooseCommissionTarget) {
          this.itemDetail.enableChooseCommissionTarget = false;
        }

        if (!this.itemDetail.enableCompanyDoc) {
          this.itemDetail.enableCompanyDoc = false;
        }

        if (!this.itemDetail.enableToken) {
          this.itemDetail.enableToken = false;
        }

        if (!this.itemDetail.enableExport) {
          this.itemDetail.enableExport = false;
        }

        if (!this.itemDetail.enableGooddealList) {
          this.itemDetail.enableGooddealList = false;
        }

        if (!this.itemDetail.enablePaymentView) {
          this.itemDetail.enablePaymentView = false;
        }

        if (!this.itemDetail.enableCCH21FinanceList) {
          this.itemDetail.enableCCH21FinanceList = false;
        }

        if (!this.itemDetail.enableEditPrice) {
          this.itemDetail.enableEditPrice = false;
        }

        if (!this.itemDetail.insurePrice) {
          this.itemDetail.insurePrice = '';
        }

        if (!this.itemDetail.richInsurePrice) {
          this.itemDetail.richInsurePrice = '';
        }

        if (!this.itemDetail.richNInsurePrice) {
          this.itemDetail.richNInsurePrice = '';
        }

        if (!this.itemDetail.finatradeInsurePrice) {
          this.itemDetail.finatradeInsurePrice = '';
        }

        if (!this.itemDetail.loanhftcInsurePrice) {
          this.itemDetail.loanhftcInsurePrice = '';
        }

        if (!this.itemDetail.century21InsurePrice) {
          this.itemDetail.century21InsurePrice = '';
        }

        if (!this.itemDetail.token) {
          this.itemDetail.token = '';
        }

        this.dialogFormVisible = true;
        //console.log(`allowClock === ${JSON.stringify(this.itemDetail)}`);
      },
      dialogBeforeClose(done) {
        this.itemDetail = Object.assign({}, this.defaultItem);
        this.uploadedFiles = [];
        if (this.$refs.ruleForm) this.$refs.ruleForm.resetFields();

        this.passwordInfo = JSON.parse(JSON.stringify({
          password: '',
          checkPassword: ''
        }));
        if (this.$refs.ruleFormPass) this.$refs.ruleFormPass.resetFields();

        this.loadData();
        if (done) {
          done();
        }
      },
      addData() {
        this.mode = 'insert';
        this.dialogFormVisible = true;
        this.itemDetail = Object.assign({}, this.defaultItem);
      },
      closeDialog() {
        this.dialogBeforeClose();
        this.dialogFormVisible = false;
        this.dialogUpdatePassword = false;
      },
      deleteData() {
        this.$confirm(`${this.$t('delete')}?`)
          .then(_ => {
            // 刪除使用者
            this.itemDetail.isDeleted = true;
            this.saveAgent(this.itemDetail);
            this.$message({
              message: this.$t('success_delete'),
              type: 'success',
            });
            this.dialogFormVisible = false;
          })
          .catch(_ => {
          });
      },
      async save() {
        if (this.mode === 'insert') {
          if (this.itemDetail.email === '') {
            this.showMessageDialog(this.$t('error'), '請輸入Email' , true , ()=>{} , ()=>{});
            return;
          }
          if (this.passwordInfo.password === '') {
            this.showMessageDialog(this.$t('error'), '請輸入密碼' , true , ()=>{} , ()=>{});
            return;
          }
          if (this.passwordInfo.password !== this.passwordInfo.checkPassword) {
            this.showMessageDialog(this.$t('error'), '密碼不相符' , true , ()=>{} , ()=>{});
            return;
          }
          // console.log(this.itemDetail);
          this.itemDetail.parentAgent = {
            agentId: this.getUserInfo.agentId
          };
          if (this.getUserInfo.parentAgent && this.getUserInfo.parentAgent.agentId) {
            this.itemDetail.parentAgent.rootAgent = this.getUserInfo.parentAgent.agentId;
          }
          this.itemDetail.password = this.passwordInfo.password;

          this.saveLoading = true;
          const response = await this.createNewAgent(this.itemDetail);
          const result = response.data;
          console.log(`result  ${JSON.stringify(result)}`);
          this.saveLoading = false;
          if (result.status === 200) {
            console.log(`createUser success ${JSON.stringify(result)}`);
            this.dialogBeforeClose();
            this.dialogFormVisible = false;
            this.showMessageDialog(this.$t('success'), this.$t('success') , true , ()=>{} , ()=>{});
          } else {
            this.showMessageDialog(this.$t('error'), result.message , true , ()=>{
              this.messageDialog.visible = false;
            } , ()=>{});
          }
        } else {
          if (!this.itemDetail.parentAgent) {
            this.itemDetail.parentAgent = {
              agentId: this.getUserInfo.agentId
            };
          }
          if (this.getUserInfo.parentAgent && this.getUserInfo.parentAgent.agentId) {
            this.itemDetail.parentAgent.rootAgent = this.getUserInfo.parentAgent.agentId;
          }

          this.saveLoading = true;
          // 是否有圖片要上傳
          if (this.uploadedFiles && this.uploadedFiles.length > 0) {
            let uploadCount = 0;
            this.uploadedFiles.sort((i1, i2) => i1.sort - i2.sort)
              .forEach((item) => {
                const params = { name: `agentImages/${item.name}`, body: item.image };
                this.uploadImageData(params)
                  .then((response) => {
                    console.log(`uploadImageData success ${response}`);
                    uploadCount += 1;
                    const path = `agentImages/${item.name}`;
                    this.getImageUrl(path)
                      .then((url) => {
                        this.itemDetail.bankImageURL = url;
                        console.log(JSON.stringify(this.itemDetail));
                        // 處理完成更新資料
                        if (this.uploadedFiles.length === uploadCount) {
                          this.saveLoading = false;
                          this.saveAgent(this.itemDetail);
                          this.dialogBeforeClose();
                          this.dialogFormVisible = false;
                        }
                      })
                      .catch((err) => {
                        console.log(`uploadImageData success ${JSON.stringify(err)}`);
                        // 處理完成更新資料
                        if (this.uploadedFiles.length === uploadCount) {
                          this.saveLoading = false;
                          this.saveAgent(this.itemDetail);
                          this.dialogBeforeClose();
                          this.dialogFormVisible = false;
                        }
                      });
                  }, (error) => {
                    this.saveLoading = false;
                    console.log(`uploadImageData error ${JSON.stringify(error)}`);
                    uploadCount += 1;
                  });
              });
          } else {
            this.saveLoading = false;
            if (!this.itemDetail.enable) { //註銷
              await this.disableUser({ email: this.itemDetail.email });
            }
            this.saveAgent(this.itemDetail);
            this.dialogBeforeClose();
            this.dialogFormVisible = false;
          }
        }
      },
      updatePassword(index, data) {
        event.stopPropagation();
        this.passwordInfo.userId = data.agentId;
        this.dialogUpdatePassword = true;
        console.log(`updatePassword ${JSON.stringify(data)}`);
      },
      savePassword() {
        this.saveLoading = true;
        // 修改使用者密碼
        fetch('https://us-central1-chiahao-92b7e.cloudfunctions.net/updatePassword', {
          method: 'POST',
          mode: 'no-cors',
          body: JSON.stringify({
            ...this.passwordInfo,
          }),
        })
          .then((res) => {
            this.saveLoading = false;
            console.debug(`updatePassword success ${res}`);
            this.dialogUpdatePassword = false;
            this.$message({
              message: this.$t('success'),
              type: 'success',
            });
          })
          .catch(error => {
            this.saveLoading = false;
            console.log(`updatePassword error ${error}`);
            this.$message({
              message: `${this.$t('error')} ${error}`,
              type: 'error',
            });
          });
      },
      filesChange(fieldName, fileList) {
        // handle file changes
        const formData = new FormData();

        if (!fileList || !fileList.length) return;

        // append the files to FormData
        Array
          .from(Array(fileList.length)
            .keys())
          .map((x) => {
            formData.append(fieldName, fileList[x], fileList[x].name);

            const file = { name: fileList[x].name, image: fileList[x] };

            this.createImage(file);
          });
      },
      createImage(file) {
        const reader = new FileReader();
        const fileName = file.name;
        this.uploadedFiles = [];
        reader.onload = (e) => {
          const image = e.target.result;
          const fileData = { name: fileName, image };
          this.uploadedFiles.push(fileData);
        };
        reader.readAsDataURL(file.image);
      },
      showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
        this.messageDialog.title = title;
        this.messageDialog.content = text;
        this.messageDialog.visible = visible;
        this.messageDialog.confirm = confirmEvent;
        this.messageDialog.cancel = cancelEvent;
      },
    },
  };
</script>

<style lang="css">
  .file {
    padding: 5px 10px;
    background: #f29b87;
    border: 1px solid #f29b87;
    position: relative;
    color: #fff;
    border-radius: 2px;
    text-align: center;
    float: left;
    cursor: pointer
  }

  .input-file {
    position: absolute;
    z-index: 1000;
    opacity: 0;
    cursor: pointer;
    right: 0;
    top: 0;
    height: 100%;
    font-size: 24px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/web/agents.vue